import React from 'react';

import { setupMobileSamlRoute as route } from '../constants';

const RouteComponent = React.lazy(() => import('.'));

export default {
  RouteComponent,
  path: route,
  name: 'setupMobileSaml',
};
